/**
 * @module Experince/Product-Selector
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
// Core Libraries
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
// import {CHANNELS, SETTINGS} from '@environment/settings';
import { PDLBaseComponent } from '@experience/reb-pdl/components/pdl.base.component';
import { PdlService } from '@experience/reb-pdl/services/pdl.service';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';

/**
 * Main Landing component for product selector
 */
@Component({
  selector: 'tmo-product-selector',
  templateUrl: './product-selector.component.html',
})
export class ProductSelectorComponent extends PDLBaseComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public routeSnapshot: ActivatedRoute,
    private stateStoreUtilsService: StateStoreUtilsService,
    pdlService: PdlService
  ) {
    super(pdlService, route);
  }

  /**
   * Loads the initial configuration of Product Selector Page
   * @returns void
   */
  public ngOnInit(): void {
    super.ngOnInit();
    const line = 'line';
    const voucher = this.route.snapshot.queryParams.voucher;
    const LineNumber = this.route.snapshot.queryParams[line];
    const isServiceEditable = this.route.snapshot.queryParams.isServiceEditable;
    const isPlanEdit = this.route.snapshot.queryParams.isPlanEdit;
    // const webChannel = SETTINGS.CHANNEL.toLowerCase() === CHANNELS.WEB.toLowerCase();
    if (voucher) {
      // if (!webChannel) {
      //   this.router.navigate(['/error']);
      // } else {
      if (LineNumber) {
        this.router.navigate(['/product-selector/activate'], {
          queryParams: { voucher: voucher, line: LineNumber },
        });
      } else {
        this.router.navigate(['/product-selector/activate'], { queryParams: { voucher: voucher } });
      }
      // }
    } else if (!isServiceEditable && !isPlanEdit) {
      this.router.navigate([
        '/product-selector/setup',
        this.stateStoreUtilsService.getFocusedTileId(),
      ]);
    } else {
      this.router.navigate(
        ['/product-selector/setup', this.stateStoreUtilsService.getFocusedTileId()],
        { queryParams: { isServiceEditable, isPlanEdit } }
      );
    }
  }

  /**
   * Destroys all the subscriptions
   * @returns {void}
   */
  public ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
